export default class CheckoutForm {

    constructor() {
        this.township = $('#checkout_township');
        this.checkbox_is_private_shop = $('#checkbox_is_private_shop');
    }

    init() {
        this.township.on('change', this.setInstitution);

        this.checkbox_is_private_shop.click(function() {
            let checked = $(this).is(':checked');
            if (checked) {
                $('#institution_wrapper').show();
            } else {
                $('#institution_wrapper').hide();
            }
        });
    }

    setInstitution() {
        let townshipId = $('#checkout_township').find(":selected").attr('data-id');

        let url = new URL(apiUrl + '/register_form/township/institutions')
        url.search = new URLSearchParams({
            township: townshipId
        })

        fetch(url)
            .then(response => response.json())
            .then(data => {
                let institutions = data.data;

                let institutionsHTML = '';
                institutions.forEach(function (newItem, index) {
                    institutionsHTML += `<option value="${newItem.name}">${newItem.name}</option>`
                })

                document.getElementById('checkout_institution').innerHTML = institutionsHTML;
            })
    }
}



// WEBPACK FOOTER //
// ./static/js/components/CheckoutForm.js